import { jsx as _jsx } from "react/jsx-runtime";
import LegalEntityMultiSelect from '../multiselect/LegalEntityMultiSelect';
export const FilterLegalEntityMultiSelect = ({ item, setFilter, activeFilters, label, isAlwaysVisible, enabled, }) => {
    var _a;
    return ({
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: enabled ? (_jsx(LegalEntityMultiSelect, { selection: (_a = activeFilters[item]) !== null && _a !== void 0 ? _a : [], onChange: value => setFilter({ [item]: value !== null && value !== void 0 ? value : undefined }), placeholder: undefined })) : null,
    });
};
